(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const active = () => !!(window.grecaptcha || document.querySelector('script[src*="recaptcha"], .grecaptcha-badge'));
    const add = () => {
      if (!active()) return;
      document.querySelectorAll('form[action*="/contact"], form[action*="/account"]').forEach((f) => {
        if (f.querySelector('.recaptcha-note')) return;
        const p = document.createElement('p');
        p.className = 'recaptcha-note';
        p.innerHTML = 'Beveiligd met reCAPTCHA. Het <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">privacybeleid</a> en de <a href="https://policies.google.com/terms" target="_blank" rel="noopener">voorwaarden</a> van Google zijn van toepassing.';
        f.appendChild(p);
      });
    };
    window.addEventListener('load', () => setTimeout(add, 800));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cx-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-row-step]');
    if (!btn) return;
    const row = btn.parentElement.querySelector('[data-row]');
    if (!row) return;
    const card = row.querySelector('.card');
    const step = card ? card.getBoundingClientRect().width * 2 : row.clientWidth * 0.8;
    row.scrollBy({ left: step * Number(btn.dataset.rowStep), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
